import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config/api";
import {
  FaUserCircle,
  FaEdit,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaIdBadge,
  FaSave,
} from "react-icons/fa";
import Swal from "sweetalert2";

function AdminProfile({ username }) {
  const [adminData, setAdminData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({});

  const fetchProfile = async () => {
    try {
      const storedUsername = username || localStorage.getItem("username");
      if (!storedUsername) return;

      const res = await axios.get(
        `${API_BASE_URL}/user/profile/${storedUsername}`
      );
      setAdminData(res.data);
      setFormData(res.data); // Database se aya hua fresh data form mein set hoga
      setLoading(false);
    } catch (err) {
      console.error("Fetch Error:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [username]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      const onlyNums = value.replace(/[^0-9]/g, "");
      if (onlyNums.length <= 10) {
        setFormData({ ...formData, [name]: onlyNums });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

 const updateProfile = async () => {
  const currentUsername = adminData.username || localStorage.getItem("username");

  const dataToSave = {
    ...formData,
    username: currentUsername // Yeh sabse zaroori hai!
  };

  try {
    const response = await axios.put(`${API_BASE_URL}/user/update-profile`, dataToSave);
    
    if (response.status === 200) {
      Swal.fire("Saved!", "Data database mein save ho gaya hai.", "success");
      setAdminData(response.data.user); // Backend se naya data set karein
      fetchProfile(); // Confirm karne ke liye dobara fetch karein
    }
  } catch (err) {
    Swal.fire("Error", "Backend tak data nahi pahuncha", "error");
  }
};
  if (loading) return <div className="p-5 text-center">Loading Profile...</div>;
  if (!adminData)
    return <div className="p-5 text-center text-danger">User Not Found!</div>;

  return (
    <div className="container-fluid p-0 animate__animated animate__fadeIn">
      {/* 1. Header Card */}
      <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: "20px", background: "#fff" }}>
        <div style={{ height: "140px", background: "linear-gradient(45deg, #097969, #40E0D0)", borderRadius: "20px 20px 0 0" }}></div>
        <div className="card-body px-4 pb-4" style={{ marginTop: "-60px" }}>
          <div className="d-flex align-items-center gap-4">
            <div className="bg-white p-1 rounded-circle shadow" style={{ width: "fit-content" }}>
              <FaUserCircle size={120} color="#097969" />
            </div>
            <div className="mt-5">
              <h2 className="fw-bold m-0" style={{ color: "#2d3436" }}>{adminData.fullName || "Admin"}</h2>
              <p className="text-muted fs-5 m-0">
                <FaIdBadge className="me-2 text-success" /> System {adminData.role}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 2. Information Details Section */}
      <div className="card border-0 shadow-sm p-4" style={{ borderRadius: "20px" }}>
        <h5 className="fw-bold mb-4" style={{ color: "#097969" }}>Personal Information</h5>
        <div className="row g-4">
          <ProfileDisplayField label="Full Name" value={adminData.fullName} />
          <ProfileDisplayField label="Email Address" value={adminData.email} icon={<FaEnvelope className="text-primary me-2" />} />
          <ProfileDisplayField label="Phone Number" value={adminData.phone} icon={<FaPhone className="text-success me-2" />} />
          <ProfileDisplayField label="City" value={adminData.city} icon={<FaMapMarkerAlt className="text-danger me-2" />} />
          <div className="col-12">
            <div className="p-3 rounded-4" style={{ background: "#f8f9fa" }}>
              <small className="text-muted fw-bold d-block mb-1 text-uppercase" style={{ fontSize: "11px" }}>Full Address</small>
              <span className="fw-bold text-dark">{adminData.address || "Address not set"}, {adminData.state}</span>
            </div>
          </div>
        </div>

        <div className="mt-5 text-end">
          <button className="btn btn-success px-5 py-2 shadow-sm" style={{ borderRadius: "12px", background: "#097969", border: "none" }} data-bs-toggle="modal" data-bs-target="#editProfileModal">
            <FaEdit className="me-2" /> Edit Profile Details
          </button>
        </div>
      </div>

      {/* 3. Modal Form */}
      <div className="modal fade" id="editProfileModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0" style={{ borderRadius: "20px" }}>
            <div className="modal-header border-0 pt-4 px-4">
              <h5 className="modal-title fw-bold" style={{ color: "#097969" }}>Update Profile Information</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body p-4">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label small fw-bold">Full Name</label>
                  <input type="text" className="form-control rounded-3 py-2" name="fullName" value={formData.fullName || ""} onChange={handleInputChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-bold">Email Address</label>
                  <input type="email" className="form-control rounded-3 py-2" name="email" value={formData.email || ""} onChange={handleInputChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-bold">Phone Number</label>
                  <input type="text" className="form-control rounded-3 py-2" name="phone" maxLength="10" value={formData.phone || ""} onChange={handleInputChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-bold">City</label>
                  <input type="text" className="form-control rounded-3 py-2" name="city" value={formData.city || ""} onChange={handleInputChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-bold">State</label>
                  <input type="text" className="form-control rounded-3 py-2" name="state" value={formData.state || ""} onChange={handleInputChange} />
                </div>
                <div className="col-12">
                  <label className="form-label small fw-bold">Address</label>
                  <textarea className="form-control rounded-3" rows="3" name="address" value={formData.address || ""} onChange={handleInputChange}></textarea>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0 pb-4 px-4">
              <button type="button" className="btn btn-light rounded-3 px-4" data-bs-dismiss="modal">Cancel</button>
              <button type="button" className="btn btn-success rounded-3 px-4" style={{ background: "#097969" }} onClick={updateProfile}>
                <FaSave className="me-2" /> Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const ProfileDisplayField = ({ label, value, icon }) => (
  <div className="col-md-6">
    <div className="p-3 rounded-4" style={{ background: "#f8f9fa" }}>
      <small className="text-muted fw-bold d-block mb-1 text-uppercase" style={{ fontSize: "11px" }}>{label}</small>
      <span className="fw-bold text-dark">{icon}{value || "N/A"}</span>
    </div>
  </div>
);

export default AdminProfile;